import React, { forwardRef, useImperativeHandle } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  pdf,
  Image,
} from "@react-pdf/renderer";
import Logo from "../assets/business/images/discount-logo.png";
import { capitalizeFirstLetter } from "./commonfunction";

// Colors & Styles
const primaryColor = "#f0913a";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 11, fontFamily: "Helvetica" },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    borderBottom: `2pt solid ${primaryColor}`,
    paddingBottom: 10,
  },
  logo: { width: 80, height: 'auto' },
  invoiceTitle: { fontSize: 25, fontWeight: "bold", color: primaryColor },

  sectionTitle: { fontSize: 12, fontWeight: "bold", marginBottom: 4 },
  text: { fontSize: 11, marginBottom: 2 },

  infoRow: { flexDirection: "row", justifyContent: "space-between", marginBottom: 20 },

  table: {
    display: "table",
    width: "auto",
    border: "1pt solid #000",
    borderRadius: 4,
    marginBottom: 20,
  },
  tableRow: { flexDirection: "row" },
  tableColHeader: {
    flex: 1,
    borderRight: "1pt solid #000",
    borderBottom: "1pt solid #000",
    backgroundColor: primaryColor,
    color: "#fff",
    padding: 6,
    fontWeight: "bold",
    textAlign: "center",
  },
  tableCol: {
    flex: 1,
    borderRight: "1pt solid #000",
    borderBottom: "1pt solid #ccc",
    padding: 6,
    textAlign: "center",
  },

  footer: { marginTop: 30, textAlign: "center", fontSize: 10, color: "#666" },
});

const InvoicePDF = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <Image style={styles.logo} src={Logo} />
        <Text style={styles.invoiceTitle}>Transaction Receipt</Text>
      </View>

      {/* Info */}
      <View style={styles.infoRow}>
        <View>
          <Text style={styles.sectionTitle}>Receipt To:</Text>
          <Text style={[styles.text, { fontWeight: "bold" }]}>{data.customerName}</Text>
          <Text style={styles.text}>Transaction ID: # {data.transactionID}</Text>
          <Text style={styles.text}>Payment Type: {capitalizeFirstLetter(data.type)}</Text>
        </View>
        <View>
          <Text style={styles.sectionTitle}>Receipt Details:</Text>
          <Text style={styles.text}>Issued By: {data.userName}</Text>
          <Text style={styles.text}>Billing Date: {data.billingDate}</Text>
          <Text style={styles.text}>Status: {capitalizeFirstLetter(data.status)}</Text>
        </View>
      </View>

      {/* Table */}
      <View style={styles.table}>
        {/* Header Row */}
        <View style={styles.tableRow}>
          <Text style={styles.tableColHeader}>Date</Text>
          <Text style={styles.tableColHeader}>Offer Name</Text>
          <Text style={styles.tableColHeader}>Discount Amount</Text>
          {/* <Text style={styles.tableColHeader}>Qty</Text> */}
          <Text style={styles.tableColHeader}>Total Amount</Text>
          <Text style={styles.tableColHeader}>Net Payable Amount</Text>
        </View>

        {/* Data Row */}
        <View style={styles.tableRow}>
          <Text style={styles.tableCol}>{data.billingDate}</Text>
          <Text style={styles.tableCol}>{data.offerName}</Text>
          <Text style={styles.tableCol}>{data.discountAmount}</Text>
          {/* <Text style={styles.tableCol}>1</Text> */}
          <Text style={styles.tableCol}>{data.totalAmount}</Text>
          <Text style={styles.tableCol}>{data.netPay}</Text>
        </View>
      </View>

      {/* Totals */}
      <View style={{ alignItems: "flex-end", marginRight: 10 }}>
        <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>Total Amount: {data.totalAmount}</Text>
        <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>Discount Amount: -{data.discountAmount}</Text>
        <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>Net Payable Amount: {data.netPay}</Text>
      </View>

      {/* Footer */}
      <Text style={styles.footer}>Thank you for your business!</Text>
    </Page>
  </Document>
);

const Invoice = forwardRef(({ transactionData, isDisplayBtn = true }, ref) => {
  const handleDownload = async () => {
    const blob = await pdf(<InvoicePDF data={transactionData} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "receipt.pdf";
    link.click();
  };

  // Expose handleDownload to parent
  useImperativeHandle(ref, () => ({
    download: handleDownload,
  }));

  return (
    <div>
      <button
        className={isDisplayBtn ? "btn btn-oring mb-2 ms-3 mt-4" : "d-none"}
        onClick={handleDownload}
      >
        Download Receipt
      </button>
    </div>
  );
});

export default Invoice;